import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { ToastPlugin, useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";
import axios from "axios";
import { VsxIcon } from "vue-iconsax";
import 'animate.css';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css'
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'
import MasonryWall from '@yeger/vue-masonry-wall'
import dayjsPlugin from './plugins/dayjs'
import { generateSignature } from "./utils/signature";

loadFonts()

// let baseUrl = 'http://0.0.0.0:8055/';
let baseUrl = 'https://v2.nooor.app/';
let baseUrl_v1 = 'https://api.nooor.app/api/';

var http = axios.create({
  baseURL: baseUrl,
  headers: {},
});

var http_v1 = axios.create({
  baseURL: baseUrl_v1,
  headers: {},
});

http.interceptors.request.use((config) => {
  // Add JWT if exists
  if (localStorage.getItem("token")) {
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  }
  const timestamp = Math.floor(Date.now() / 1000);
  const method = config.method.toUpperCase();

  let rawUrl = config.url;

  // If axios produces absolute URL → isolate the pathname
  if (rawUrl.startsWith('http://') || rawUrl.startsWith('https://')) {
    rawUrl = new URL(rawUrl).pathname;
  }

  // Strip query params
  let cleanPath = rawUrl.split('?')[0];

  // Ensure leading slash
  if (!cleanPath.startsWith('/')) cleanPath = '/' + cleanPath;

  const signature = generateSignature(method, cleanPath, timestamp);

  config.headers['X-TIMESTAMP'] = timestamp;
  config.headers['X-SIGNATURE'] = signature;

  return config;
});



http.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    if (err.response.data.errors == undefined) {
      return Promise.reject(err);
    }
    let errCode = err.response.data.errors[0].extensions.code;
    if (err.response.status === 401 && (errCode === "TOKEN_EXPIRED")) {
      const originalConfig = err.config;
      originalConfig._retry = true;
      let refreshHttp = axios.create({
        baseURL: baseUrl,
        headers: {},
      });
      try {
        const res = await refreshHttp.post("auth/refresh", {
          refresh_token: localStorage.getItem("refresh"),
          mode: "json",
        });

        localStorage.setItem("userInfo", JSON.stringify(res.data));
        localStorage.setItem("token", res.data.data.access_token);
        localStorage.setItem("refresh", res.data.data.refresh_token);

        return http(originalConfig);
      } catch (_error) {
        useToast().error("انتهت صلاحية الجلسة .. سيتم تسجيل الخروج من الحساب", { duration: 10000 });
        setTimeout(() => {
          localStorage.clear();
          window.location.reload();
        }, 5000);
        return Promise.reject(_error);
      }
    }

    return Promise.reject(err);
  },
);


let app = createApp(App).use(router).use(store).use(vuetify).use(ToastPlugin, {
  position: "bottom",
});

app.component("VsxIcon", VsxIcon);
app.component('VueDatePicker', VueDatePicker);
app.config.globalProperties.$axios = http;
app.config.globalProperties.$apiV1 = http_v1;
app.use(VueTippy);
app.use(ContextMenu);
app.use(dayjsPlugin, { locale: 'ar' });
app.use(MasonryWall);
app.mount("#app");